import Vue from 'vue';
export const bus = new Vue();

// 添加调试代码来确认事件触发
const originalEmit = bus.$emit
bus.$emit = function(event, ...args) {
  console.log('Bus emit:', event, args)
  return originalEmit.call(this, event, ...args)
}
export default bus